module.exports = __webpack_public_path__ + "enterprise-app-ui-design.1d4WqsHW.svg";